var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandingDownloadLogo = function SvgBrandingDownloadLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 413,
    height: 303,
    viewBox: "0 0 413 303"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 58,
    x: 233,
    y: 112,
    fill: "current",
    fillRule: "evenodd",
    opacity: 0.2
  })));
};
export default SvgBrandingDownloadLogo;